module.exports = __webpack_public_path__ + "img/create-treatment-button-desktop-ru.94025b2f.jpg";